import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateRequestInvoiceModel, ProjectTransactionInvoiceDetailModel } from './../../../../model/builk/package-sale/create-request-invoice.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectorModel } from '../../../../model/shared/selector.model';
import { AddressService } from '../../../../service/api/builk/address.service';
import { ISubscription } from 'rxjs-compat/Subscription';
import { CheckProvinceSelectorModel } from '../../../../model/shared/check-province-selector.model';
import { RelateTaxInvoiceType, RequestTaxInvoiceType } from './../../../../enum/builk/package-sale/request-tax-invoice-type.enum';
import { TaxInvoiceCompanyTypeEnum } from '../../../../enum/builk/package-sale/tax-invoice-company-type.enum';
import { PackageSaleService } from '../../../../service/api/builk/package-sale.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-tax-invoice-modal',
  templateUrl: './tax-invoice-modal.component.html',
  styleUrls: ['./tax-invoice-modal.component.scss']
})
export class TaxInvoiceModalComponent {

  // ViewChild
  @ViewChild("template") template: TemplateRef<any>;

  //bs bootstrap
  public modalRef: BsModalRef;

  // string
  country: string = "TH";
  province: string;
  district: string;
  refid: string = '-';
  relate: string;
  transactionCode: string;

  // number
  userSurrKey: number;
  companySurrKey: number;
  transactionSurrKey: number;
  branch: number;
  relateOf: number;
  personTypeTemp: number;

  // boolean
  isCreating: boolean = false;
  isLoading: boolean = false;
  isDetail: boolean = true;
  isNotNeedInvoice: boolean = false;
  isHasPersonType: boolean = false;
  isNoRequestingInvoice: boolean = false;

  // form
  invoiceForm: FormGroup;

  // object
  createInvoiceModel: CreateRequestInvoiceModel = new CreateRequestInvoiceModel();
  detailInvoice: ProjectTransactionInvoiceDetailModel = new ProjectTransactionInvoiceDetailModel();
  provinceCode: CheckProvinceSelectorModel = new CheckProvinceSelectorModel();

  // array
  countryList: Array<SelectorModel> = [];
  provinceList: Array<SelectorModel> = [];
  districtList: Array<SelectorModel> = [];

  // subscribe
  subscription: ISubscription;

  constructor(
    private packageService: PackageSaleService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private formBuilder: FormBuilder,
    private addressSelectorService: AddressService,
    private route: ActivatedRoute,
    private modalService: BsModalService,
  ) {
    this.userSurrKey = this.localStorageService.get("userSurrKey");
    this.companySurrKey = this.localStorageService.get("companySurrKey");
  }

  initData() {
    this.initForm();
    this.getDetailByRelate();
    this.getCountry('th');
  }

  openModal(refId: string): void {
    this.refid = refId;
    this.relate = "package";
    this.initData();
    this.modalRef = this.modalService.show(
      this.template, { class: "modal-lg custom-invoice" });
  }

  openCustomCostcodeModal(refId: string): void {
    this.refid = refId;
    this.relate = "customcostcode";
    this.initData();
    this.modalRef = this.modalService.show(
      this.template, { class: "modal-lg" });
  }

  close(): void {
    this.modalRef.hide();
  }

  getDetailByRelate() {
    switch (this.relate) {
      case "package":
        this.relateOf = RelateTaxInvoiceType.package;
        this.getInvoiceDetail(this.refid);
        break;
      case "customcostcode":
        this.relateOf = RelateTaxInvoiceType.customcostcode;
        this.getInvoiceCustomCostcodeDetail(this.refid);
        break;
      default:
        alert('relate is invalid');
        break;
    }
  }
  getInvoiceDetail(id: string) {
    this.isLoading = true;
    this.packageService.getProjectTransactionInvoiceDetail(id).subscribe(res => {
      if (res != null) {
        this.transactionSurrKey = res.transactionSurrKey;
        this.transactionCode = res.transactionCode;
        switch (res.requestTaxInvoiceType) {
          case RequestTaxInvoiceType.sent:
            this.detailInvoice = res;
            this.initDetail();
            this.isDetail = true;
            break;
          case RequestTaxInvoiceType.notNeed:
            this.isDetail = true;
            this.isNotNeedInvoice = true;
            break;
          default:
            if (res.personType != undefined && res.personType != null) {
              this.personTypeTemp = res.personType;
              this.createInvoiceModel.packageInvoiceType = res.personType;
              this.isHasPersonType = true;
              this.invoiceForm.controls["personType"].clearValidators();
              this.invoiceForm.controls["personType"].updateValueAndValidity();
            } else {
              this.isHasPersonType = false;
              this.invoiceForm.controls["personType"].setValidators([Validators.required, Validators.nullValidator]);
              this.invoiceForm.controls["personType"].updateValueAndValidity();
            }
            this.isDetail = false;
            break;
        }
      } else {
        this.isDetail = false;
      }
      this.isLoading = false;
    });
  }

  initForm() {
    this.createInvoiceModel = new CreateRequestInvoiceModel();
    this.invoiceForm = this.formBuilder.group({
      personType: ["", [Validators.required, Validators.nullValidator]],
      fullName: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^\S.*\S$/)]],
      email: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
      phoneNumber: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^[0-9]+$/)]],
      contactName: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^\S.*\S$/)]],
      branch: [""],
      taxNumber: ["", [Validators.required, Validators.minLength(13), Validators.maxLength(13), Validators.nullValidator, Validators.pattern(/^[0-9]+$/)]],
      taxAddress: ["", [Validators.required, Validators.nullValidator]],
      taxPhoneNumber: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^[0-9]+$/)]],
      country: ["", [Validators.required, Validators.nullValidator]],
      province: ["", [Validators.required, Validators.nullValidator]],
      district: ["", [Validators.required, Validators.nullValidator]],
      branchName: [""],
      postcode: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^[0-9]+$/)]],
    });
  }

  validateForm(): boolean {
    let checkFormValidate = false;
    this.invoiceForm.controls["personType"].markAsTouched();
    this.invoiceForm.controls["fullName"].markAsTouched();
    this.invoiceForm.controls["email"].markAsTouched();
    this.invoiceForm.controls["phoneNumber"].markAsTouched();
    this.invoiceForm.controls["contactName"].markAsTouched();
    this.invoiceForm.controls["taxNumber"].markAsTouched();
    this.invoiceForm.controls["taxAddress"].markAsTouched();
    this.invoiceForm.controls["taxPhoneNumber"].markAsTouched();
    this.invoiceForm.controls["country"].markAsTouched();
    this.invoiceForm.controls["province"].markAsTouched();
    this.invoiceForm.controls["district"].markAsTouched();
    this.invoiceForm.controls["postcode"].markAsTouched();

    if (this.createInvoiceModel.packageInvoiceType == TaxInvoiceCompanyTypeEnum.JuristicPerson) {
      this.invoiceForm.controls["branch"].setValidators([Validators.required, Validators.nullValidator]);
      this.invoiceForm.controls["branch"].updateValueAndValidity();
      this.invoiceForm.controls["branch"].markAsTouched();
    } else {
      this.invoiceForm.controls["branch"].clearValidators();
      this.invoiceForm.controls["branch"].updateValueAndValidity();
    }

    if (this.branch == 2) {
      this.invoiceForm.controls["branchName"].setValidators([Validators.required, Validators.nullValidator, Validators.pattern(/^\S.*\S$/)]);
      this.invoiceForm.controls["branchName"].updateValueAndValidity();
      this.invoiceForm.controls["branchName"].markAsTouched();
    } else {
      this.invoiceForm.controls["branchName"].clearValidators();
      this.invoiceForm.controls["branchName"].updateValueAndValidity();
    }

    checkFormValidate = this.invoiceForm.valid;
    return checkFormValidate;
  }

  initDetail() {
    this.createInvoiceModel.packageInvoiceType = this.isHasPersonType ? this.personTypeTemp : this.detailInvoice.packageInvoiceType;
    this.createInvoiceModel.name = this.detailInvoice.name;
    this.createInvoiceModel.email = this.detailInvoice.email;
    this.createInvoiceModel.phone = this.detailInvoice.phone;
    this.createInvoiceModel.contactName = this.detailInvoice.contactName;
    this.createInvoiceModel.taxId = this.detailInvoice.taxId;
    this.createInvoiceModel.taxPhone = this.detailInvoice.taxPhone;
    this.createInvoiceModel.address = this.detailInvoice.address;
    this.createInvoiceModel.postcode = this.detailInvoice.postcode;

    this.branch = this.detailInvoice.branch == "สำนักงานใหญ่" ? 1 : ((this.detailInvoice.branch != '' && this.detailInvoice.branch != undefined) ? 2 : undefined);

    if (this.branch == 2) {
      this.createInvoiceModel.branch = this.detailInvoice.branch;
    }

    this.country = this.detailInvoice.countryCode;
    this.province = this.detailInvoice.provinceCode;
    this.district = this.detailInvoice.districtCode;
  }

  async getCountry(language: string) {
    this.countryList = await this.addressSelectorService.getCountry(language).toPromise();
    this.onChangeCountry();
  }

  onChangeCountry(): any {
    this.provinceList = undefined;
    this.getProvince(this.country, 'th');
  }

  async getProvince(countryCode: string, language: string) {
    this.provinceList = await this.addressSelectorService.getProvince(countryCode, language).toPromise();
    this.subscription = this.addressSelectorService.checkProvince(this.province)
      .subscribe(Response => {
        this.provinceCode = Response;
        if (this.provinceCode.value !== "-") {
          this.province = this.provinceCode.value;
        }
        this.onChangeProvince();
      });
  }

  onChangeProvince(): any {
    this.districtList = [];
    this.getDistrict(this.province);
  }

  async getDistrict(provinceCode: string) {
    if (provinceCode && (!Number.isNaN(parseInt(provinceCode))))
      this.districtList = await this.addressSelectorService
        .getDistrict(provinceCode, 'th')
        .toPromise();
  }

  onJuristicPersonChange() {
    if (this.createInvoiceModel.packageInvoiceType == TaxInvoiceCompanyTypeEnum.JuristicPerson) {
      this.branch = 1; // 1 = "สำนักงานใหญ่"
    } else if (this.createInvoiceModel.packageInvoiceType == TaxInvoiceCompanyTypeEnum.Individual) {
      this.branch = undefined;
    }
  }

  get TaxInvoiceCompanyType(): typeof TaxInvoiceCompanyTypeEnum {
    return TaxInvoiceCompanyTypeEnum;
  }

  getInvoiceCustomCostcodeDetail(id: string) {
    this.isLoading = true;
    this.packageService.getCustomCostcodeTransactionInvoiceDetail(id).subscribe(res => {
      if (res != null) {
        this.transactionSurrKey = res.transactionSurrKey;
        this.transactionCode = res.transactionCode;
        switch (res.requestTaxInvoiceType) {
          case RequestTaxInvoiceType.sent:
            this.detailInvoice = res;
            this.initDetail();
            this.isDetail = true;
            break;
          case RequestTaxInvoiceType.notNeed:
            this.isDetail = true;
            this.isNotNeedInvoice = true;
            break;
          default:
            if (res.personType != undefined && res.personType != null) {
              this.personTypeTemp = res.personType;
              this.createInvoiceModel.packageInvoiceType = res.personType;
              this.isHasPersonType = true;
              this.invoiceForm.controls["personType"].clearValidators();
              this.invoiceForm.controls["personType"].updateValueAndValidity();
            } else {
              this.isHasPersonType = false;
              this.invoiceForm.controls["personType"].setValidators([Validators.required, Validators.nullValidator]);
              this.invoiceForm.controls["personType"].updateValueAndValidity();
            }
            this.isDetail = false;
            break;
        }
      } else {
        this.isDetail = false;
      }
      this.isLoading = false;
    });
  }
}
